import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePayOrderInfo = defineStore('payOrderInfo', () => {
  const payOrderId = ref<any>([])
  const hasAcceptBankCallback = ref(false)
  const isRefreshData = ref(false)
  function setPayOrderId(ids: string[]) {
    payOrderId.value = ids
  }
  function setHasAcceptBankCallback(has: boolean) {
    hasAcceptBankCallback.value = has
  }
  function refreshData(isRefresh: boolean) {
    isRefreshData.value = isRefresh
  }
  return {
    payOrderId,
    setPayOrderId,
    hasAcceptBankCallback,
    setHasAcceptBankCallback,
    refreshData,
    isRefreshData
  }
})
